import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35194842

export const getToyBricksInfo = createAsyncThunk(
  'ToyBricks/live/commonactivity/get_html_page_config',
  async (id: number, store: any) => {
    const resp = await http.post('/live/commonactivity/get_html_page_config', {
      ...store.getState().env.deviceinfo,
      id,
    })
    return resp.data.data
  }
)

const initialState: any = {}
export const ToyBricksSlice = createSlice({
  name: 'ToyBricks',
  initialState,
  reducers: {
    setEditState: (state, action) => {
      const {module_ids, id, activity_id} = action.payload
      const ret: any = {
        id,
        activity_id,
        module_ids: {},
      }
      Object.keys(module_ids).forEach((key) => {
        if (!ret.module_ids[key]) {
          ret.module_ids[key] = {}
        }
        module_ids[key].forEach((v) => {
          ret.module_ids[key][v.logic_id] = v.module_id
        })
      })
      Object.assign(state, ret)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getToyBricksInfo.fulfilled, (state, action) => {
      const {module_ids, id, activity_id, json_data} = action.payload
      const ret: any = {
        id,
        activity_id,
        module_ids: {},
      }
      Object.keys(module_ids).forEach((key) => {
        if (!ret.module_ids[key]) {
          ret.module_ids[key] = {}
        }
        module_ids[key].forEach((v) => {
          ret.module_ids[key][v.logic_id] = v.module_id
        })
      })
      try {
        const {components, layout, customData} = JSON.parse(json_data)
        ret.EditDataState = {
          components,
          layout,
          other: {
            customData,
          },
        }
      } catch (error) {
        //
      }
      Object.assign(state, ret)
    })
  },
})
export default ToyBricksSlice.reducer
